import React from 'react';
import PropTypes from 'prop-types';
import laroute from '@/shared/laroute';
import jpMoment from '@/shared/jp_moment';

export default class DetailStatus extends React.Component {
    render() {
        return <React.Fragment>{this._renderDayTime()}</React.Fragment>;
    }

    _renderDayTime() {
        const date = this.props.date;
        const fairDays = Object.entries(this.props.fairDays);
        const detailStatusDom = fairDays.map((fairDay, i) => {
            // 選択した日付の開催時間がない場合はnull
            if (fairDay[0] !== date) {
                return null;
            }
            const dayTime = fairDay[1][0];
            const reserveLink = laroute.route('user.reservation.create', {
                fair_id: dayTime.hall_fair_id,
                fair_date: date,
            }); // クエリストリングがつくので末尾に / を入れない

            const timeDom = this._timeList(dayTime.times);
            const isReservable = this._countReservableTime(dayTime.times) > 0;

            return (
                <div
                    className="fair-detail-status__box background-color--contents_bg"
                    key={i}
                >
                    <p className="fair-detail-status__day border-color--border">
                        {this.props.formattedDate}
                    </p>
                    <ul className="fair-detail-status__list">{timeDom}</ul>
                    { isReservable ? this._renderReserveButton(reserveLink) : ''}
                </div>
            );
        });

        return detailStatusDom;
    }

    // 日付ごとの開催時間一覧作成
    _timeList(times) {
        if (!times) {
            return null;
        }

        const timeDom = times.map((time, i) => {
            let remindType = (
                <span className="icon_round color--sub-before"></span>
            );
            if (time.remainder === '1') {
                remindType = <span className="icon_trigone"></span>;
            } else if (time.remainder === '2') {
                remindType = (
                    <span className="fair-detail-status__full">満</span>
                );
            }
            const startTime = jpMoment(time.start_time, 'HH:mm:ss').format(
                'HH:mm',
            );
            let endTime = '';
            if (time.end_time) {
                endTime = jpMoment(time.end_time, 'HH:mm:ss').format('HH:mm');
            }

            return (
                <li className="fair-detail-status__item" key={i}>
                    {remindType}
                    {startTime}~{endTime}
                </li>
            );
        });

        return timeDom;
    }

    // 予約可能な開催時間の数
    _countReservableTime(times) {
        return times.filter((time) => {
            return time.remainder === '0' || time.remainder === '1';
        }).length;
    }

    // CVボタン描画
    _renderReserveButton(link) {
        if (!this.props.isCustomForm) {
            return null;
        }

        return (
            <div className="fair-detail-status__btn">
                <a
                    href={link}
                    className="action-btn--reserve border-radius--btn linear-gradient--accent font-family--middle"
                    data-ct="reserve"
                >
                    <span className="action-btn--reserve__icon">
                        <span className="icon_cal"></span>
                    </span>
                    このフェアを予約
                </a>
            </div>
        );
    }
}

/**
 * date: 選択した日付(YYYY-mm-dd)
 * formattedDate: 選択した日付を描画用に整形したもの（YYYY年mm月dd日（曜日））
 * fairDays: 開催日付と時間一覧
 * isCustomForm: オリジナルフォーム利用しているか
 */
DetailStatus.propTypes = {
    date: PropTypes.string.isRequired,
    formattedDate: PropTypes.string.isRequired,
    fairDays: PropTypes.object.isRequired,
    isCustomForm: PropTypes.bool.isRequired,
};
